import { selectModalType } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useModalType = () => useSelector(selectModalType);

export default useModalType;
